module.exports = __webpack_public_path__ + "img/num_layout_01.35e058a6.png";